import { render, staticRenderFns } from "./TipoProcessamentoPreparo.vue?vue&type=template&id=39c1aa81&"
import script from "./TipoProcessamentoPreparo.vue?vue&type=script&lang=js&"
export * from "./TipoProcessamentoPreparo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports